import TransactionsModalsDepositFormContent from './Content';
import TransactionsModalDepositContentFormLayout from './Layout';
import { TransactionModalsDepositContentTransactionFormProps } from './props';

/**
 * TransactionModalsDepositContentTransactionForm Component
 * This component is responsible for rendering the deposit form content within a specific layout.
 *
 * @param {TransactionModalsDepositContentTransactionFormProps} props - The properties for the component.
 * @param {JSX.Element} props.additionalContent - Additional content to be rendered within the form layout.
 *
 * @returns {JSX.Element} The rendered component displaying the deposit form content within the specified layout.
 *
 * @example
 * // Usage example:
 * const additionalContent = <div>Additional Content</div>;
 * <TransactionModalsDepositContentTransactionForm additionalContent={additionalContent} />
 */
export default function TransactionModalsDepositContentTransactionForm({
  additionalContent,
}: TransactionModalsDepositContentTransactionFormProps) {
  return (
    <TransactionsModalDepositContentFormLayout
      additionalContent={additionalContent}
    >
      <TransactionsModalsDepositFormContent />
    </TransactionsModalDepositContentFormLayout>
  );
}
